
<template>

    <div class="RadioButtonList"
         ControlType="RadioButtonList"
         ref="Element"
         v-show="FinalVisible">

  
        <span v-for="(option,index) in m_Attribute.Options"
              @change="OnValueChange"
              @click="OnLabelClick(option)"
              :class="{Checked:option.Value==m_Value,'Disabled':!GetOptionAbility(option)}">
            <input type="radio"
                   v-model="m_Value"
                   :disabled="(!FinalEnabled)"
                   :readonly="FinalReadOnly"
                   :value="option.Value" /> <span style="padding-left:2px;" v-html="option.Text"></span>
            &nbsp;
            <div v-if="((index+1)%m_Attribute.RepeatColumns)==0"></div>
        </span>

    </div>



</template>

<script scoped>
    import TControlBase from '@/Common/TControlBase';
    import Utility from '@/Common/Utility';
    import FieldOptionService from '@/Common/FieldOptionService';

    export default {
        data() {
            return {
                m_RepeatColumns: 1000,
                m_Value: "" ,

                m_Attribute: TControlBase.Attribute({
                    Options: []
                })
            }
        }
        ,
        //props: ["value", "Attribute", "RepeatColumns", "OptionName", "Options", "OptionAbilityHandler"],

        props: [...TControlBase.BaseProps],

        computed: {

            //FinalOptions: function () {
            //    let options = [];

            //    if (this.Attribute != null && this.Attribute.Options != null) {
            //        options = this.Attribute.Options;
            //    }

            //    if (this.m_Attribute.Options.length > 0) {
            //        options.push(...this.m_Attribute.Options);
            //    }

            //    return options;
            //},

            //Disabled: function () {
            //    let result = false;

            //    if (this.Attribute != null && this.Attribute.Enabled != null) {
            //        result = !this.Attribute.Enabled;
            //    }

            //    return result;
            //}
            //,
            //CssClass: function () {
            //    let result = "";


            //    if (this.Attribute != null && this.Attribute.CssClass != null) {
            //        result = this.Attribute.CssClass;
            //    }

            //    return result;
            //}
            //,


            //ReadOnly: function () {

            //    let result = false;


            //    if (this.Attribute != null && this.Attribute.ReadOnly != null) {
            //        result = this.Attribute.ReadOnly;
            //    }

            //    return result;
            //}

        }
        ,

        methods: {

            GetOptionAbility(option) {
                let ability = true;

                if (this.m_Attribute.OptionAbilityHandler != null) {
                    ability = this.m_Attribute.OptionAbilityHandler(option.Value);
                }

                return ability;
            },

            OnValueChange(e) {
                this.DoOnValueChange(e);
            },

            OnLabelClick(option) {
                if (this.GetOptionAbility(option)) {
                    this.m_Value = option.Value;
                    this.OnValueChange();
                }
            },

            UpdateElementByAttribute() {

            },

            ResetValue() {

            },


        },

        mounted() { 

            this.DoOnMounted();
        },

        beforeMounted() {

        },

        created() {

            TControlBase.call(this);

            //this.m_Value = this.value;

 

            //if (this.OptionName != null) {
            //    let dataLangauge;

            //    if (window.location.href.indexOf("Backend") > 0) {
            //        dataLangauge = Utility.GetBag("BackendDataLanguage");
            //    }
            //    else {
            //        dataLangauge = Utility.GetBag("DataLanguage");
            //    }
 
            //}

            //if (this.Options != null && this.Options.length > 0) {
            //    if (this.m_Attribute.Options == null) {
            //        this.m_Attribute.Options = [];
            //    }

            //    this.m_Attribute.Options.push(...this.Options);
            //}

            //this.UpdateElementByAttribute();

        },

        watch: {
            //value: function (newVal, oldVal) {


            //    this.CheckedValue = newVal;

            //},

            //Attribute: function () {

            //    this.UpdateElementByAttribute();
            //},
        }


    }
</script>

<style scoped>
    .RadioButtonList span {
 
    }
</style>
